import React, { FC, ReactNode } from 'react';
import MessageBanner from 'components/common/message-banner';
import useMessageBanner from '../../hooks/useMessageBanner';

interface HomePageLayoutProps {
  header: ReactNode;
  sidebar: ReactNode;
  document: ReactNode;
  hideSideBar: boolean;
}

const HomePageLayout: FC<HomePageLayoutProps> = ({ header, sidebar, document, hideSideBar }) => {
  const { messageBanner } = useMessageBanner();
  return (
    <div id="home-page-layout">
      <header id="page-header">{header}</header>
      {messageBanner && <MessageBanner {...messageBanner} />}
      <main id="page-body">
        <section id="sidebar" className={hideSideBar ? 'no-border' : ''}>
          {sidebar}
        </section>
        <section id="document">{document}</section>
      </main>
    </div>
  );
};

export default HomePageLayout;
